import { axios } from '@Root/API'

export const getRolesOptions = () => {
	return axios.get('roles')
}
